import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    TransformBillingDetails
} from './transform';

import {
    setAction as setBillingAction,
    selectAction as selectBillingAction,
    Billing,
    resetAction
} from 'one-state-billing-details';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    SETBILLING = 'set-billing/set',
    BILLINGDETAILS = 'one-state-billing-details/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const setBilling = (payload: any) => ({ type: Types.SETBILLING, payload });
const pushtoSetBillingDetails = (payload: any) => setBillingAction(payload);
const pushSelectedBillingDataToState = (payload: any) => selectBillingAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchBillingDetailsFromEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server,
            log,
            agentId,
            alertnotification,
            settings:
            {
                servers,
                epicendpoints: { getbillingdetails, apitoken },
                uisettings: {
                    dashboardapiconfig: {
                        getbillingdetails : getbillingdetailsApi
                    }
                },
                compatible : { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "getbillingDetailsEpic request", dataresponse);
                const getBillingDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(getbillingdetails + "?PatientID=" + payload?.id, "", apitoken, locations, log, 'GET', alertnotification);

                    } else { 
                        response = server.get({
                            path: getbillingdetails + "?PatientID=" + payload?.id,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,getbillingDetailsEpic-epic",
                                    "fetch-getbillingDetails-EPIC", {
                                    responseresult
                                }
                                );
                                  // SEND to ALERT snotificiton/NOCserver for errors
                                if(responseresult?.status === 0) {
                                    if(alertnotification?.isEnabled()){
                                        var timestamp=new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code" : "930-31" ,
                                            "error_type": "SERVER_ERROR" ,
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype":"SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert":"Yes",
                                            "timestamp": timestamp ,
                                            "params":responseresult
                                        });
                                    }
                                }
                                let sourceerror: ErrorObject = {
                                    source: "Billing",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return sourceerror;
                            })
                        log.debug("one-epics", "getbillingDetailsEpic response", response);
                    }
                    return from(response);
                }
                if (!getbillingdetailsApi) return []
                return getBillingDetails(dataresponse).pipe(
                    flatMap((response: any) => {
                        const actions: any = [
                            setBilling(response)
                        ];
                        if (response && (response.status >= 400 || response.type == "error")) {
                            actions.push(addAction(response));
                            let disp: Disposition = { value: "1007" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = response.status;
                            disp.meta03 = response.erroritems?.[0]?.error_detail;
                            disp.meta04 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "190" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = '200';
                            disp.meta03 = 'client';
                            actions.push(pushToDisposition(disp));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Function is used to fetch billing details
 * @param context contains settings json etc ..
 */
export const pushBillingDetailsToState = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETBILLING),
            mergeMap((action: any) => {
                /**
                 * @param response contains the appointment response
                 */
                let response = action.payload;
                log.debug("one-epics", "fetch Billing Details request", response);
                if (response) {
                    const performBillingTransformation = (datares: any) => {
                        let result = TransformBillingDetails(response, context);
                        log.debug("one-epics", "fetch Billing Details response", result);
                        return from([result]);
                    }
                    return performBillingTransformation(response).
                        pipe(
                            map((transformresponse: any) => pushtoSetBillingDetails(transformresponse?.billingdata))
                        )
                }
                else{
                    return from([]);
                }                  
            })

        )
    }
);

/**
 * This function is used to push the default selected value
 * for billing module.
 * @param context has logger etc.
 */
export const pushSelectedBillingData = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.BILLINGDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the request to select default billing details
                 */
                let dataresponse = action.payload;
                const getRequest = (datares: any) => {
                    const billing: Billing[] = state$.value.billingdetails?.values;
                    let selectedbilling: string = "";
                    if(billing?.length > 0){
                        selectedbilling = billing[0].AccountId;
                    }
                    log.debug("one-epics", "pushSelectedBillingData response", selectedbilling);
                    return from([selectedbilling]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => pushSelectedBillingDataToState(response))
                )
            })

        )
    }
);

/**
 * Listen for component clear and intiate state clear for Billing
 * @param context  contains logger which is used for logging
 */
export const clearBillingEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, billing-epic",
            "clear-billing-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED,PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);